import React, { useState } from 'react';
import DfErrorMessage from '../components/df-error-message-component';

export type ErrorType = string | null;

export type ErrorContextType = {
  error: ErrorType;
  setError: (error: ErrorType) => void;
} | null;

export const ErrorContext = React.createContext<ErrorContextType>(null);

export const ErrorBoundary: React.FC<{ children: React.ReactNode; slimError?: boolean }> = ({
  children,
  slimError = false,
}) => {
  const [error, setError] = useState<ErrorType>(null);

  const setErrorCB = (error: any) => {
    setError(error);
  };

  const child =
    error === 'ServerError' ? <DfErrorMessage slim={slimError}></DfErrorMessage> : children;

  return (
    <ErrorContext.Provider value={{ error: error, setError: setErrorCB }}>
      {child}
    </ErrorContext.Provider>
  );
};

export default ErrorBoundary;
